module.exports = function() {
  return new Worker(__webpack_public_path__ + "a052a0a30667420a4a7e.worker.js");
};